import { useState, useRef } from 'react';
import { ThumbsUpIcon } from '../../components';
import { Badge } from 'react-bootstrap';

function ProgressIcon(props) {
  const {
    content_group,
    size
  } = props;

  // Memoize computed values for performance
  const hasNoRevisions = content_group?.stage?.revisions?.length === 0;
  const isApprovedStage = content_group?.stage?.approved_content_group_stage_id;
  const isApproved = content_group?.stage?.approved;

  const sizeClass = size === 'md' ? 'badge-md' : '';

  // Not submitted
  if (!isApprovedStage) return null;

  // Approved with no Revisions
  if (isApproved && hasNoRevisions) {
    return <Badge className={`badge-outline ${sizeClass}`} bg='success' pill>Approved</Badge>
  }

  // Submitted
  if (hasNoRevisions) {
    return (
      <Badge className={`badge-outline ${sizeClass}`} bg='success' pill>Sent</Badge>
    );
  }

  // With Revisions
  return (
    <Badge className={`badge-outline ${sizeClass}`} bg='orange' pill>Revision</Badge>
  );
}

export { ProgressIcon };
